// Application types

const PROFILE = {
  LOADING_AUTH: "LOADING_AUTH",
  MY_PROFILE: "MY_PROFILE",
  UPDATING: "UPDATING",
};

export default PROFILE;
